import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { CoreDialogService } from 'src/app/core/dialogs/core-dialog.service';
import { ReportsService } from '../../reports.service';
import { UntypedFormControl, UntypedFormGroup, NgForm, Validators } from '@angular/forms';
import { EntitiesService } from 'src/app/configuration/entities.service';
import { TasksActionTypesService } from 'src/app/tasks/tasks-action-types.service';
import { UsersService } from 'src/app/users/users.service';
import { LoginService } from 'src/app/login/login.service';
import { CoreFormService } from 'src/app/core/forms/core-forms.service';

@Component({
  selector: 'app-report-create-task',
  templateUrl: './report-create-task.component.html',
  styleUrls: ['./report-create-task.component.scss']
})
export class ReportCreateTaskComponent implements OnInit {
  @ViewChild("formDetails") public formDetails: NgForm;
  public myForm = new UntypedFormGroup({
    task_action_id: new UntypedFormControl('', Validators.required),
    task_action_description: new UntypedFormControl(''),
    responsible_user_id: new UntypedFormControl('', Validators.required),
    task_action_scheduled_date: new UntypedFormControl('', Validators.required),
    task_action_scheduled_date_end: new UntypedFormControl(''),
  });
  public organizations: any = [];
  public selected: any[] = [];
  public tasksActionTypes: any = [];
  public responsibles: any = [];
  public connectedUser: any = {};
  public action: any = {
    task_action_scheduled_date: new Date()
  };
  public task: any = {
    responsible_user_id: parseInt(this.loginService.get("userId")),
    organizationIds: []
  };
  public results: any = [];
  public totalRows: number = 0;
  public rows: any = Array<any>();
  public entity: any = {};
  public reportId: number;


  constructor(private route: ActivatedRoute,
    private messageService: MessageService,
    private config: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private coreDialogService: CoreDialogService,
    private datePipe: DatePipe,
    private reportsService: ReportsService,
    private entitiesService: EntitiesService,
    private coreFormService: CoreFormService,
    private tasksActionTypesService: TasksActionTypesService,
    private loginService: LoginService,
    private usersService: UsersService) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.loadData(this.config.data.reportId, this.config.data.reportResults, this.config.data.entity);
    });
    this.loadTasksActionTypes();
    this.loadResponsibles();
  }

  loadData(reportId: number, results: any, entity: any) {
    this.reportId = reportId;
    this.results = results;
    this.rows = this.results.values;
    this.totalRows = this.rows.length;
    this.entity = entity;

    this.selected = this.rows.map(m => m.base_id + "");

    console.log(this.reportId);
    console.log(this.results);
    console.log(this.rows);
    console.log(this.selected);

    this.myForm.patchValue({
      responsible_user_id: this.task.responsible_user_id,
      task_action_id: null,
      task_action_description: null,
      task_action_scheduled_date: null,
      task_action_scheduled_date_end: null,
    });
  }

  getCalendarInputClass(type): string {
    switch (type) {
      case 0:
        return this.myForm.get('task_action_scheduled_date').invalid && this.myForm.get('task_action_scheduled_date').touched ? 'ng-invalid' : '';
      case 1:
        return this.myForm.get('task_action_scheduled_date_end').invalid && this.myForm.get('task_action_scheduled_date_end').touched ? 'ng-invalid' : '';
    }
  }

  loadTasksActionTypes() {
    this.tasksActionTypesService.all({}).subscribe(
      data => {
        this.tasksActionTypes = data.rows;
      }
    )
  }
  loadResponsibles() {
    this.usersService.all({}).subscribe(
      data => {
        this.responsibles = data.rows;
        this.responsibles.unshift({ id: -2, name: "Responsable de la entidad base" });
        this.responsibles.unshift({ id: -1, name: "Responsable de la organización" });
      },
      error => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: error.error.title });
      }
    )
    /*this.usersService.get(this.loginService.get("userId")).subscribe(
      data => {
        this.connectedUser = data;
      },
      error => {
        this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: error.error.title });
      }
    )*/
  }
  getNumberOfDays(start, end) {
    const date1 = new Date(start);
    const date2 = new Date(end);

    // One day in milliseconds
    const oneDay = 1000 * 60 * 60 * 24;

    // Calculating the time difference between two dates
    var d2 = date2.getTime();
    var d1 = date1.getTime() - (date1.getTime() % 86400000);

    const diffInTime = d2 - d1;

    // Calculating the no. of days between two dates
    const diffInDays = Math.round(diffInTime / oneDay);

    return diffInDays + 1;

  }

  getTotalPerDay() {

    let numDays = 1;
    if (this.myForm.get('task_action_scheduled_date').value != null) {
      if (this.myForm.get('task_action_scheduled_date_end').value != null) {

        numDays = this.getNumberOfDays(this.myForm.get('task_action_scheduled_date').value, this.myForm.get('task_action_scheduled_date_end').value);
      }
      if (Number.isInteger(this.selected.length / numDays)) {
        return "Se crearán " + this.selected.length / numDays + " actividades al día";
      } else {
        return "Las actividades se repartirán equitativamente entre los " + numDays + " días."
      }
    }

  }

  validar() {
    if (this.task.task_action_id == null || this.task.task_action_id == 0) return false;
    if (this.task.responsible_user_id == null || this.task.responsible_user_id == 0) return false;
    if (this.task.task_action_scheduled_date == null) return false;
    if (this.task.task_action_scheduled_date_end == null) return false;
    if (this.task.task_action_description == null) return false;
    return true;
  }

  save() {
    //console.log("¿Validate?", this.coreFormService.validate(this.formDetails));
    //console.log("¿Validate!?", !this.coreFormService.validate(this.formDetails));
    //console.log("formDetails", this.formDetails);
    if (this.validar() == false) {
      this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: "Todos los campos deberían tener un valor." });
      return;
    }

    let organizationsIds = this.selected.map(m => m.id);
    this.reportsService.addMultiplesTasks(this.task, this.selected, this.reportId, organizationsIds).subscribe(
      res => {
        this.messageService.add({ closable: false, severity: 'success', summary: 'Actividades creadas correctamente' });
        this.dynamicDialogRef.close("success");
      },
      error => {
        this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: error.error.title });
      }
    );
    this.dynamicDialogRef.close();
  }
  cancel() {
    this.dynamicDialogRef.close();
  }

  getRowValue(header, value = "", item) {

    if (typeof (this.entity.fields) !== "undefined") {

      let field = this.entity.fields.find(m => m.id == header.entity_field_id);
      let property = field.model_property;
      if (field.model_property_label != null && field.model_property_label != "") property = field.model_property_label;

      let formatFn = field.formatFn;
      if (formatFn == null && field.configuration != null && field.configuration.formatFn != null) {
        formatFn = field.configuration.formatFn;
      }
      if (formatFn != null) {
        var format = formatFn.split("|");
        if (format[0] == "date") value = this.formatDate(value, format);
        if (format[0] == "suffix") value = this.formatSuffix(value, format);
        if (format[0] == "phone") value = this.formatPhone(value, format);
        if (format[0] == "mail") value = this.formatMail(value, format);
        if (format[0] == "www") value = this.formatWWW(value, format);
        //if (format[0] == "badge") value = this.formatBadge(field, value, format);
        if (format[0] == "image") value = this.formatImage(field, format);
        if (format[0] == "currency") value = this.formatCurrency(value, format);
        if (format[0] == "number") value = this.formatNumber(value, format);
      }
      if (value == null || value == "") value = " ";
    }
    return value;
  }

  formatDate(value: any, args: any[]) {
    return this.datePipe.transform(value, args[1]);
  }
  formatSuffix(value: any, args: any[]) {
    return value + args[1];
  }
  formatPhone(value: any, args: any[]) {
    if (value == null) return "";
    var formattedValue = "<a href='tel:" + value + "'>" + value + "</a>";
    return formattedValue;
  }
  formatMail(value: any, args: any[]) {
    if (value == null) return "";
    var formattedValue = "<a href='mailto:" + value + "'>" + value + "</a>";
    return formattedValue;
  }
  formatWWW(value: any, args: any[]) {
    if (value == null) return "";
    var formattedValue = "<a href='" + value + "' target='_blank'>" + value + "</a>";
    return formattedValue;
  }
  formatBadge(field: any, value: any, args: any[]) {
    //TODO: Falta revisar este.
    if (value == null) return "";
    let className = "";
    let subClassName = "";
    if (field) {
      let refValue = "";
      if (args[1] != "") {
        try {
          let valorID = eval("row." + field.model_property);
          subClassName = args[1] + valorID;
        } catch (e) {
          console.error(`Error evaluando this.model.${field.entityField.model_property}`);
        }
      }
      className = "badge badge-block " + subClassName;
      var formattedValue = "<div class='" + className + "'>" + value + "</div>";
    }
    return formattedValue;
  }
  formatImage(value: any, args: any[]) {
    if (value == null) return "";
    var formattedValue = `<div class="d-flex justify-content-left align-items-center"><div class="avatar-wrapper"><div class="avatar  me-1"><img src="../../../app-assets/images/avatars/2-small.png" alt="Avatar" height="32" width="32"></div></div><div class="d-flex flex-column"><a href="app-user-view.html" class="user_name text-truncate"><span class="fw-bold">Zsazsa McCleverty</span></a><small class="emp_post text-muted">@zmcclevertye</small></div></div>`;
    return formattedValue;
  }
  formatCurrency(value: any, args: any[]) {
    if (value == null) return "0 €";
    var formattedValue = new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(value);
    return formattedValue;
  }
  formatNumber(value: any, args: any[]) {
    if (value == null) return "0";
    var formattedValue = new Intl.NumberFormat("de-DE").format(value)
    return formattedValue;
  }

  onSubmit() {
    this.myForm.markAllAsTouched();

    console.log("this.myForm.value", this.myForm.value);
    console.log("this.myForm.valid", this.myForm.valid);
    let organizationsIds = this.selected.map(m => m.id);
    if (this.myForm.valid == false) {
      this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: "Por favor, revise el formulario." });
      return;
    }
    console.log("task ->", this.task);
    console.log("this.selected ->", this.selected);
    console.log("this.reportId ", this.reportId);
    console.log("this.organizationsIds: ", organizationsIds);
    //let organizationsIds = this.selected.map(m => m.id);
    
    Object.assign(this.task, this.myForm.value);
    
    console.log("task final ", this.task);
    this.reportsService.addMultiplesTasks(this.task, this.selected, this.reportId, organizationsIds).subscribe(
      res => {
        this.messageService.add({ closable: false, severity: 'success', summary: 'Actividades creadas correctamente' });
        this.dynamicDialogRef.close("success");
      },
      error => {
        this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: error.error.title });
      }
    );
    this.dynamicDialogRef.close();
  }
}
